'use client'

import CircularProgress from '@mui/material/CircularProgress'
import MUIStack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import PropTypes from 'prop-types'

export const LoadingState = ({ sx }) => {
  const theme = useTheme()
  const { teal } = theme?.palette?.support || { teal: 'blue' }

  return (
    <MUIStack sx={sx} alignItems="center" justifyContent="center" data-testid="loading">
      <CircularProgress aria-label="Loading" sx={{ 'svg circle': { stroke: teal } }} />
    </MUIStack>
  )
}

LoadingState.propTypes = {
  sx: PropTypes.object
}
